export default {
	namespaced: true,
	state: {
		accessToken: '',
		refreshToken: '',
		claims: {},
	},
	mutations: {
		setAccessToken(state, accessToken) {
			state.accessToken = accessToken;
			if(accessToken) {
				let decoder = new TextDecoder(); // default 'utf-8' or 'utf8'
				let byteArr = base64ToArrayBuffer(accessToken.split('.')[1]);
				state.claims = JSON.parse(decoder.decode(byteArr));
			}
			else state.claims = {}
		},
		setRefreshToken(state, refreshToken) {
			state.refreshToken = refreshToken;
		},
	},
	getters: {
		ACCESS_TOKEN(state) {
			return state.accessToken;
		},
		REFRESH_TOKEN(state) {
			return state.refreshToken;
		},
		LOGIN_ROLE_ID(state) {
			return state.claims.loginRoleId;
		},
	},
};

function base64ToArrayBuffer(base64) {
	var binaryString = atob(base64);
	var bytes = new Uint8Array(binaryString.length);
	for (var i = 0; i < binaryString.length; i++) {
		bytes[i] = binaryString.charCodeAt(i);
	}
	return bytes.buffer;
}